import axiosPrivate from "./axiosPrivate";

const getViaticos = () => {
    return axiosPrivate.get("viaticos").then(response => response);
};

const insertViaticos = (data) => {
    return axiosPrivate.post("viaticos", data).then(response => response);
};

const updateViaticos = (id, data) => {
    return axiosPrivate.put(`viaticos/${id}`, data).then(response => response);
};

const deleteViaticos = (id) => {
    return axiosPrivate.delete(`viaticos/${id}`).then(response => response);
};

export default {
    getViaticos,
    insertViaticos,
    updateViaticos,
    deleteViaticos
};
